module.exports = __webpack_public_path__ + "static/img/zichan_02.ee04399.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zichan_02.png
// module id = 1q3R
// module chunks = 1